import { useEffect, useState } from 'react'

interface GenerationEtaProps {
  startedAt: string
  targetDurationMinutes: number
  className?: string
}

// Baseline: a 10-min episode takes ~10 min of wall-clock to generate end-to-end,
// based on recent production runs. Scales linearly with target audio length.
const WALL_MINUTES_PER_AUDIO_MINUTE = 1

export function GenerationEta({ startedAt, targetDurationMinutes, className }: GenerationEtaProps) {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 5000)
    return () => clearInterval(t)
  }, [])

  const estimatedTotalSec = Math.max(60, targetDurationMinutes * WALL_MINUTES_PER_AUDIO_MINUTE * 60)
  const elapsedSec = Math.max(0, (now - new Date(startedAt).getTime()) / 1000)
  const remainingSec = estimatedTotalSec - elapsedSec

  let label: string
  if (remainingSec <= 0) {
    label = 'Almost done…'
  } else if (remainingSec < 60) {
    label = 'Less than 1 min remaining'
  } else {
    const remainingMin = Math.ceil(remainingSec / 60)
    label = `~${remainingMin} min remaining`
  }

  return <span className={className}>{label}</span>
}
